import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BATCH_STATUS_POLLING } from "../../constants/bulkProcessConstant";

import { makeRequestAuth } from "../../utils/globals";
import { Banner, Button, Icon } from "@plum-xoxo/admin-dsm";

import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import styled from "styled-components";

const StyledFileDiv = styled.div`
  background: ${(props) => props.theme.palette.light.c100};
  border-radius: 8px;
  padding: 24px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  width: 478px;
`;

const ScanError = ({
  uploadFileMsg,
  uploading,
  fileName,
  activeScreen,
  currentAmount,
  final_file_path,
  scheduledAmount,
  status,
  total_rows,
  total_validation_error,
  toggleRemoveFile,
  uploadAgain,
  processing,
  currencyCode = "INR",
}) => {
  const handleUrl = (fileUrl) => {
    const downloadData = {
      query: "stores.mutation.fileDownload",
      tag: "stores",
      variables: {
        add_data: fileUrl,
      },
    };
    makeRequestAuth(
      downloadData,
      function (resp) {
        if (
          resp &&
          resp.data &&
          resp.data.fileDownload &&
          resp.data.fileDownload.output
        ) {
          let response = JSON.parse(resp.data.fileDownload.output);
          let url = "data:" + response.type + ";base64," + response.data;
          var link = document.createElement("a");
          link.download = response.filename;
          link.href = url;
          link.click();
        }
      }.bind(this)
    );
  };

  const failStatus = [
    BATCH_STATUS_POLLING.FAILURE,
    BATCH_STATUS_POLLING.VALIDATION_FAILURE,
    BATCH_STATUS_POLLING.CANCELLED,
  ];

  return (
    <>
      <div className="emptyData w-100 d-flex flex-column">
        <div className="w-50 m-auto d-flex flex-column align-items-center">
          {uploadFileMsg ? (
            <Banner color="error" iconName="" description={uploadFileMsg} />
          ) : null}
          {!total_validation_error && !failStatus.includes(status) ? (
            <>
              <Typography.H3
                className="mb-8 text-center"
                color="dark"
                shade="c300"
              >
                File Verified Successfully!
              </Typography.H3>
              <Typography
                className="mb-20 text-center"
                color="dark"
                shade="c200"
              >
                File has been verified. You can proceed to send your reward
              </Typography>
              <StyledFileDiv>
                <div className="d-flex align-items-center justify-content-between">
                  <Icon
                    iconName="PlumCheckbox"
                    color="green"
                    shade="c300"
                    size="24"
                  />
                  <Typography.HelperText
                    className="ml-16"
                    color="dark"
                    shade="c300"
                  >
                    {fileName}
                  </Typography.HelperText>
                </div>
                <div>
                  <Button
                    variant="plain"
                    color="primary"
                    onClick={toggleRemoveFile}
                  >
                    Remove
                  </Button>
                </div>
              </StyledFileDiv>
            </>
          ) : total_validation_error > 0 && failStatus.includes(status) ? (
            <>
              <Typography.H3
                className="mb-8 text-center"
                color="red"
                shade="c300"
                component={"div"}
              >
                {total_validation_error} Error
                {total_validation_error > 1 ? "s" : ""} Found
              </Typography.H3>
              <Typography
                className="mt-20 mb-0"
                color="dark"
                shade="c200"
                component={"span"}
              >
                We have highlighted the errors for you.{" "}
              </Typography>
              <Typography
                className="d-flex align-items-center justify-content-center mt-8"
                component={"div"}
                style={{ width: "368px" }}
              >
                {final_file_path ? (
                  <a
                    href="javascript:void(0)"
                    onClick={() => {
                      handleUrl(final_file_path);
                    }}
                  >
                    {" "}
                    <Typography
                      className="d-contents mr-4"
                      color="blue"
                      shade="c200"
                      component={"span"}
                    >
                      Download the file
                    </Typography>{" "}
                  </a>
                ) : null}
                <Typography color="dark" shade="c200" component={"span"}>
                  to fix them and upload again.
                </Typography>
              </Typography>
              <StyledFileDiv>
                <div className="d-flex align-items-center justify-content-between">
                  <Icon
                    iconName="PlumWarning"
                    color="red"
                    shade="c200"
                    size="24"
                  />
                  <Typography.HelperText
                    className="ml-16"
                    color="dark"
                    shade="c300"
                  >
                    {fileName.length > 30
                      ? `${fileName.slice(0, 30)}...`
                      : fileName}
                  </Typography.HelperText>
                </div>
                <div>
                  <Button
                    variant="plain"
                    color="primary"
                      onClick={() => {
                        uploadAgain(0, "reopenfileupload");
                      }}
                  >
                    Upload Again
                  </Button>
                </div>
              </StyledFileDiv>
            </>
          ) : (
            <>
              <Typography.H3
                className="mb-8 text-center"
                color="dark"
                shade="c300"
              >
                File Verified Successfully!
              </Typography.H3>
              <Typography
                className="mb-20 text-center"
                color="dark"
                shade="c200"
              >
                We have found an error. Please fix it to send your rewards
              </Typography>
              <StyledFileDiv>
                <div className="d-flex align-items-center justify-content-between">
                  <Icon
                    iconName="PlumCheckbox"
                    color="green"
                    shade="c200"
                    size="20"
                  />
                  <Typography.HelperText
                    className="ml-16"
                    color="dark"
                    shade="c300"
                  >
                    {fileName}
                  </Typography.HelperText>
                </div>
                <div>
                  <Button
                    variant="plain"
                    color="primary"
                    onClick={toggleRemoveFile}
                  >
                    Remove
                  </Button>
                </div>
              </StyledFileDiv>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    bulkProcessReducer: {
      bulkUploadData: {
        uploadFileMsg = "",
        uploading = false,
        fileName = "",
        activeScreen = 0,
        processing = 0,
        batchProcessData: {
          currentAmount = 0,
          final_file_path = "",
          scheduledAmount = 0,
          status = "",
          total_rows = 0,
          total_validation_error = 0,
        },
      } = {},
    } = {},
  } = state;
  return {
    uploadFileMsg,
    uploading,
    fileName,
    activeScreen,
    currentAmount,
    final_file_path,
    scheduledAmount,
    status,
    total_rows,
    total_validation_error,
    processing,
    bulkUploadData: state.bulkProcessReducer.bulkUploadData,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ScanError);
